import { render, staticRenderFns } from "./detail_kpi.vue?vue&type=template&id=5ea720f3"
import script from "./detail_kpi.vue?vue&type=script&lang=js"
export * from "./detail_kpi.vue?vue&type=script&lang=js"
import style0 from "./detail_kpi.vue?vue&type=style&index=0&id=5ea720f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports